import { render } from "./CryptoWatch.vue?vue&type=template&id=2b679032&scoped=true"
import script from "./CryptoWatch.vue?vue&type=script&lang=js"
export * from "./CryptoWatch.vue?vue&type=script&lang=js"

import "./CryptoWatch.vue?vue&type=style&index=0&id=2b679032&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b679032"]])

export default __exports__